import { Typography } from '@mui/material';
import { createSelector } from '@reduxjs/toolkit';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { useGetFeatureFlagsQuery } from '../../../../api/features';
import { useGetLegalDocumentsQuery } from '../../../../api/legal-documents';
import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { formatCentsCurrency } from '../../../../general/utils/formatters';
import { UbosForm } from '../../../application/components/ubos-form';
import { selectCreditTerms } from '../../../application/reducers/credit-terms.reducer';
import { selectnextStep } from '../../../application/reducers/next-step';

const selector = createSelector([selectnextStep, selectCreditTerms], (nextStep, { creditTerms }) => ({
  creditLimit: creditTerms?.finalCreditLimit,
  loading: nextStep.loading,
}));

const ReviewApplicationPage: FC = () => {
  const { creditLimit, loading } = useSelector(selector);

  const { data, isFetching: isFetchingLegalDocs } = useGetLegalDocumentsQuery();
  const commercialFinancingDisclosure = data?.entities.commercial_financing_disclosure;

  const { data: featureFlags } = useGetFeatureFlagsQuery();
  const reorderedFlowEnabled = featureFlags?.fgEnableReorderedCreditAppFlow ?? false;

  const offerSummaryDoc = reorderedFlowEnabled ? undefined : commercialFinancingDisclosure;

  return (
    !loading &&
    !isFetchingLegalDocs &&
    !!creditLimit && (
      <WizardPage
        title={
          <>
            Review your application for a <br />
            <Typography component="span" color="primary" variant="inherit">
              {formatCentsCurrency(creditLimit)}
            </Typography>{' '}
            credit limit
          </>
        }
        footer={<YouCanComeBackNote />}
      >
        <UbosForm
          submitLabel="Submit"
          attestationVerb="submitting"
          submitAction="get_ubos"
          offerSummaryDoc={offerSummaryDoc}
        />
      </WizardPage>
    )
  );
};

export { ReviewApplicationPage };
